import { ComponentProps } from "react";
import * as S from "./styles";

type ButtonCustomProps = ComponentProps<"button">;
export const ButtonCustom = (props: ButtonCustomProps) => {
  return <S.ButtonCustomStyle {...props} />;
};
